module.exports = __webpack_public_path__ + "static/media/Gilroy-Semibold.813d26b3.woff";